StatementsManager.HANDLERS.SkillAnswered = StatementHandler.extend({

	handleBlockInitialized: function(e) {
		StatementHandler.prototype.handleBlockInitialized.call(this, e);

		var block = e.blockData.view;
		if(block instanceof CardQuestion) {
			this.listenTo(block, "onRatingSelected", this.handleOnRatingSelected);
		}
	},

	handleOnRatingSelected: function(e) {
		var rating = e.skill.getRating() + 1; // starts from 0
		var options =  e.target.data.options;

		var item = {
			question: Utils.stripHTML(e.target.data.question.question),
			skillTitleURI: encodeURI(e.target.data.question.id),
			skillTitle: e.skill.getTitle(),
			rating: rating,
			scoreRaw: parseInt(rating, 10),
			scoreMin: 1,
			scoreMax: options.length,
			scoreScaled: rating / options.length
		};

		for(var i = 0; i < options.length; i++) {
			item["scale" + (i + 1)] = options[i].title;
		}

		this.addDataItem(item);
		this.ready();
	}
});
